import { IReward } from './IReward';
import { Reward } from './Reward';

export class IbLoginFeeReductionReward extends Reward {
	public static readonly CLASS: string = 'com.bancvue.rcx.config.product.rewards.api.IbLoginFeeReductionReward';

	public static readonly NAME: string = 'IB Login Fee Reduction';

	ibLoginFeeReductionAmount: number = 0;

	constructor(reward?: IReward) {
	  super(IbLoginFeeReductionReward.CLASS, reward ? reward.id : null);

	  if (reward) {
	    this.ibLoginFeeReductionAmount = (reward as any).ibLoginFeeReductionAmount;
	  }
	}

	getDescription(): string {
	  return `$${this.ibLoginFeeReductionAmount} fee reduction if IB Login qualifier met.`;
	}

	clone(): IReward {
	  const clone = new IbLoginFeeReductionReward();
	  Object.assign(clone, this);
	  return clone;
	}
}

export default IbLoginFeeReductionReward;
